import type { AgendaDay, AgendaSection } from "../../types";

export const automotiveVenturesAgendaSections: AgendaSection[] = [
  { number: "01", title: "Introductions", duration: "15 min" },
  { number: "02", title: "Demo", duration: "45 min" },
  { number: "03", title: "Platform", duration: "50 min" },
  { number: "04", title: "Discussion", duration: "30 min" },
];

export const automotiveVenturesAgenda: AgendaDay[] = [
  {
    date: "Friday, May 15",
    label: "Day 1",
    sessions: [
      {
        time: "10:00 AM",
        title: "Arrive On-Site",
        audience: "On-site",
        description: "Setup and introductions with the Automotive Ventures team",
      },
      {
        time: "1:00 – 3:30 PM (2.5h)",
        title: "Main Session",
        audience: "On-site attendees",
        description:
          "Full deck: Introductions → Demo → Platform → Discussion",
      },
    ],
  },
];
